export default __webpack_public_path__ + "static/media/bg.9089f216.jpg";